/* Ported from Panel Jaulas v18.dc.html; real data is supplied by PanelRuntime. */
/* eslint-disable */
import React from 'react';
import canvasInteractionLogic from "./logic/canvasInteractionLogic";
import comparisonViewLogic from "./logic/comparisonViewLogic";
import evolutionAggregateLogic from "./logic/evolutionAggregateLogic";
import evolutionVariantsLogic from "./logic/evolutionVariantsLogic";
import evolutionNavigationLogic from "./logic/evolutionNavigationLogic";
import evolutionChartLogic from "./logic/evolutionChartLogic";
import periodLogic from "./logic/periodLogic";
import causeAnalysisLogic from "./logic/causeAnalysisLogic";
import summaryLogic from "./logic/summaryLogic";
import versusLogic from "./logic/versusLogic";
import drawerLogic from "./logic/drawerLogic";
import feederScoreLogic from "./logic/feederScoreLogic";
import depthLogic from "./logic/depthLogic";
import detailLogic from "./logic/detailLogic";
import presentationLogic from "./logic/presentationLogic";
export default
/**
 * Núcleo de estado y ciclo de vida del panel SCAPP V2.
 *
 * La lógica de cada dominio se incorpora al prototipo desde la carpeta logic; esta clase
 * conserva únicamente listeners, referencias ligadas y el estado compartido.
 */
class PanelLogic extends React.Component {
  /**
   * Configura el lienzo lógico usado por las medidas relativas al viewport.
   *
   * El render ya ocupa directamente 100 vw por 100 vh; interactionScale conserva
   * la sensibilidad original de los gestos calculada sobre la base 1920 × 1080.
   */
  fitVals() {
    const width = typeof window !== 'undefined' ? window.innerWidth : 1920;
    const height = typeof window !== 'undefined' ? window.innerHeight : 1080;
    return {
      scale: 1,
      interactionScale: Math.min(width / 1920, height / 1080) || 0.5,
      offX: 0,
      offY: 0,
      cW: 1920,
      cH: 1080
    };
  }
  componentDidMount() {
    this._fit = () => {
      // Layout is derived from the window in fitVals(); this only re-renders.
      this.setState({
        winW: window.innerWidth,
        winH: window.innerHeight
      });
    };
    this._fit();
    window.addEventListener('resize', this._fit);
    this._esc = e => {
      if (e.key === 'Escape' && this.state.exp) this.setState({
        exp: null
      });
      const st = this.state;
      if (st.view === 'cmp' && st.cMode !== 'sup' && (e.key === 'ArrowLeft' || e.key === 'ArrowRight') && !/INPUT|TEXTAREA|SELECT/.test((e.target || {}).tagName || '')) {
        const d = this._cmp,
          R = d && d.dIdx;
        if (!R || !R.length) return;
        e.preventDefault();
        const i = st.cFocus == null ? -1 : R.indexOf(st.cFocus),
          n = i < 0 ? e.key === 'ArrowRight' ? 0 : R.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + R.length) % R.length;
        this.setState({
          cFocus: R[n]
        });
      }
    };
    window.addEventListener('keydown', this._esc);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this._fit);
    window.removeEventListener('keydown', this._esc);
  }
  componentDidUpdate(prevProps, prevState) {
    // A detail zoom belongs to one cage/day only. Keeping it after changing the
    // selection makes the next day look truncated even though its data exists.
    if ((prevState.sel !== this.state.sel || prevState.day !== this.state.day) && this.state.zm) {
      this.setState({
        zm: null,
        drag: null,
        hi: null
      });
      return;
    }
    document.querySelectorAll('[data-wheel-zoom]').forEach(el => {
      if (!el._nw) {
        el._nw = true;
        el.addEventListener('wheel', ev => {
          if (!(ev.target.closest && ev.target.closest('[data-tip-scroll]'))) ev.preventDefault();
        }, {
          passive: false
        });
      }
    });
    const prevHd = this._prevHd;
    this._prevHd = this.state.rkHd;
    if (this.state.rkHd !== prevHd && this.state.rkHd != null) {
      const box = [...document.querySelectorAll('[data-rk-scroll]')].find(b => b.offsetParent !== null);
      const N = this.data.days.length,
        len = this.state.rkRange || 14;
      const d1 = len >= N ? N - 1 : Math.min(N - 1, Math.max(len - 1, this.state.day)),
        d0 = Math.max(0, d1 - Math.min(len, N) + 1);
      const row = box && box.querySelector('[data-rk-day="' + (d0 + this.state.rkHd) + '"]');
      if (row) box.scrollTop = Math.max(0, row.offsetTop - box.clientHeight / 2 + row.offsetHeight / 2);
    }
    this.draw();
    const cv = document.querySelector('canvas[data-cmp-canvas]');
    if (cv && !cv._nw) {
      cv._nw = true;
      cv.addEventListener('wheel', ev => {
        if (this.state.cMode === '3d') ev.preventDefault();
      }, {
        passive: false
      });
    }
  }
  cvRef = el => {
    this._cv = el;
    if (el) this.draw();
  };
  cDown = e => {
    e.preventDefault();
    this._dragMoved = false;
    this._drag = {
      pan: e.shiftKey || e.button === 2,
      px: this._panX ?? 0,
      py: this._panY ?? 0,
      x: e.clientX,
      y: e.clientY,
      yaw: this._yaw ?? -0.55,
      pitch: this._pitch ?? 0.8
    };
  };
  cWheel = e => {
    if (this.state.cMode !== '3d') return;
    const cv = e.currentTarget,
      r = cv.getBoundingClientRect();
    const mx = (e.clientX - r.left) / r.width * cv.width - cv.width / 2,
      my = (e.clientY - r.top) / r.height * cv.height - cv.height * 0.56;
    const z0 = this._zoom ?? 1,
      z1 = Math.max(0.5, Math.min(6, z0 * Math.exp(-e.deltaY * 0.0015))),
      k = z1 / z0;
    this._panX = mx - (mx - (this._panX ?? 0)) * k;
    this._panY = my - (my - (this._panY ?? 0)) * k;
    this._zoom = z1;
    this.setState({
      cZoom: z1
    });
    this.draw();
  };
  cZoomBy = f => () => {
    const z0 = this._zoom ?? 1,
      z1 = Math.max(0.5, Math.min(6, z0 * f)),
      k = z1 / z0;
    this._panX = (this._panX ?? 0) * k;
    this._panY = (this._panY ?? 0) * k;
    this._zoom = z1;
    this.setState({
      cZoom: z1
    });
    this.draw();
  };
  cOut = () => {
    this._drag = null;
    if (this.state.cTipC) this.setState({
      cTipC: null
    });
  };
  cHit = e => {
    const cv = e.currentTarget,
      g = this._geo,
      d = this._cmp;
    if (!g || !d || !d.metrics) return null;
    const r = cv.getBoundingClientRect(),
      x = (e.clientX - r.left) / r.width * cv.width,
      y = (e.clientY - r.top) / r.height * cv.height;
    const nd = d.metrics[0].z.length,
      nb = d.metrics[0].z[0].length;
    if (g.mode === 'map') {
      const b = Math.floor((x - g.L) / g.cw);
      if (b < 0 || b >= nb) return null;
      for (let k = 0; k < g.nm; k++) {
        const top = g.gap * (k + 1) + g.bh * k,
          rr = Math.floor((y - top) / g.ch);
        if (y >= top && rr >= 0 && rr < nd) return {
          r: rr,
          b,
          k,
          px: x / cv.width,
          py: y / cv.height
        };
      }
      return null;
    }
    let best = null,
      bd = 900;
    for (let k = 0; k < d.metrics.length; k++) for (let rr = 0; rr < nd; rr++) for (let b = 0; b < nb; b++) {
      const p = g.P(b / Math.max(1, nb - 1), g.Ym(rr, k), d.metrics[k].z[rr][b]);
      const dd = (p[0] - x) ** 2 + (p[1] - y) ** 2;
      if (dd < bd) {
        bd = dd;
        best = {
          r: rr,
          b,
          k,
          px: p[0] / cv.width,
          py: p[1] / cv.height
        };
      }
    }
    return best;
  };
  cDragH = e => {
    if (!this._drag) {
      const h = this.cHit(e),
        o = this.state.cTipC;
      if (!h) {
        if (o) this.setState({
          cTipC: null
        });
      } else if (!o || o.r !== h.r || o.b !== h.b || o.k !== h.k) this.setState({
        cTipC: h
      });
      return;
    }
    if (this.state.cMode !== '3d') return;
    if (this.state.cTipC) this.setState({
      cTipC: null
    });
    const s = this.fitVals().interactionScale;
    if (this._drag.pan) {
      const cv = e.currentTarget,
        r = cv.getBoundingClientRect(),
        q = cv.width / r.width;
      this._panX = this._drag.px + (e.clientX - this._drag.x) * q;
      this._panY = this._drag.py + (e.clientY - this._drag.y) * q;
      this._dragMoved = true;
      this.draw();
      return;
    }
    this._yaw = this._drag.yaw + (e.clientX - this._drag.x) / s * 0.006;
    this._pitch = Math.max(0.12, Math.min(1.45, this._drag.pitch + (e.clientY - this._drag.y) / s * 0.005));
    if (Math.abs(e.clientX - this._drag.x) + Math.abs(e.clientY - this._drag.y) > 4) this._dragMoved = true;
    this.draw();
  };
  cUp = e => {
    const moved = this._dragMoved;
    this._drag = null;
    this._dragMoved = false;
    if (moved) return;
    const h = this.cHit(e),
      d = this._cmp;
    if (!d || !d.dIdx) return;
    if (!h) {
      if (this.state.cFocus != null) this.setState({
        cFocus: null
      });
      return;
    }
    const dd = d.dIdx[h.r];
    this.setState({
      cFocus: this.state.cFocus === dd ? null : dd
    });
  };
  state = {
    sortKey: 'alarms',
    sortDir: -1,
    sel: 0,
    day: 0,
    hover: null,
    hmMetric: 'alarms',
    tier: 'Media',
    evoMetric: 'compacta',
    smooth: true,
    cmp: null,
    evoGroup: 'dia',
    evoAxis: 'fecha',
    hi: null,
    ah: null,
    nh: null,
    gFocus: null,
    sMetric: 'alarms',
    sGroup: 'dia',
    sLines: null,
    sType: 'barras',
    evoTab: 'evo',
    view: 'panel',
    exp: null,
    cMode: 'sup',
    cMetrics: ['act', 'tasa', 'ppa'],
    cLen: 14,
    cEnd: null,
    cDays: null,
    cDayPick: false,
    cHover: null,
    sAxis: 'fecha',
    sHc: null,
    ppaHoverDay: null,
    zm: null,
    drag: null,
    showDailyCauseAnalysis: false,
    hiddenDetailMetrics: []
  };
  get data() {
    const F = this.full,
      s = this.state || {},
      N = F.days.length,
      a0 = s.rngA ?? 0,
      b0 = s.rngB ?? N - 1,
      a = Math.max(0, a0),
      b = Math.min(N - 1, b0),
      k = a0 + '-' + b0;
    if (this._rk === k) return this._rd;
    this._dk = null;
    this._czp = null;
    this._scd = null;
    this._da = null;
    this._rk = k;
    if (a > b) return this._rd = {
      ...F,
      empty: true,
      off: 0,
      days: F.days.slice(0, 1),
      rows: F.rows.map(r => ({
        ...r,
        cells: r.cells.slice(0, 1)
      })),
      tiers: {
        Baja: [],
        Media: [],
        Alta: []
      }
    };
    const set = new Set(F.days.slice(a, b + 1)),
      tiers = {};
    Object.keys(F.tiers).forEach(t => tiers[t] = F.tiers[t].filter(e => set.has(e.date)));
    return this._rd = {
      ...F,
      off: a,
      days: F.days.slice(a, b + 1),
      rows: F.rows.map(r => ({
        ...r,
        cells: r.cells.slice(a, b + 1)
      })),
      tiers
    };
  }
}
Object.assign(PanelLogic.prototype, canvasInteractionLogic, comparisonViewLogic, periodLogic, causeAnalysisLogic, summaryLogic, versusLogic, drawerLogic, feederScoreLogic, depthLogic, detailLogic, evolutionAggregateLogic, evolutionVariantsLogic, evolutionNavigationLogic, evolutionChartLogic, presentationLogic);
